export default __webpack_public_path__ + "static/media/success.0e163e83.png";